// src/views/ApiExampleView.vue
<template>
  <div>
    <h2>Ejemplo de uso de ApiService</h2>
    <button @click="fetchData">Cargar datos</button>
    <div v-if="loading">Cargando...</div>
    <pre v-if="data">{{ data }}</pre>
    <div v-if="error" style="color: red">{{ error }}</div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { ApiService } from '../services/apiService'

const api = new ApiService()
const data = ref<Post>()
const loading = ref(false)
const error = ref<string | null>(null)

async function fetchData() {
  loading.value = true
  error.value = null
  try {
    data.value = await api.get('/posts/1')
  } catch (e: unknown) {
    error.value = e instanceof Error ? e.message : 'Error al cargar datos'
  } finally {
    loading.value = false
  }
}

export interface Post {
  userId: number
  id: number
  title: string
  body: string
}
</script>
